import { useContaCommand } from '@/commandbar/commandBar.service'
import useDynamicTransactionFields, { FieldConfigKey } from '@/transaction/create-transaction/transaction-fields.controller'
import { usePanelManager } from '@tritt/multipanel'
import { CREATE_TRANSACTION } from '@/transaction/create-transaction/index'
import { PanelContentRequest } from '@tritt/multipanel'

const { registerCommand } = useContaCommand()


const { selectedConfigKey, fieldConfigPresets } = useDynamicTransactionFields()

const activatePreset = (preset: FieldConfigKey) => {
    selectedConfigKey.value = preset
    const payload: PanelContentRequest = { ...CREATE_TRANSACTION }
    const { setPanelPath } = usePanelManager()
    setPanelPath(payload)
}

fieldConfigPresets.value.forEach(preset => {
    registerCommand({
        type: 'Bilagsføring',
        typeLabel: 'Bilagsføring',
        icon: 'i-ph-textbox',
        label: preset.label,
        key: 'preset-' + preset.value,
        activate: () => activatePreset(preset.value as FieldConfigKey),
        isActive: () => selectedConfigKey.value === preset.value
    })
})

